import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export interface ShareLink {
  token: string;
  shareUrl: string;
}

export function useShareLink(tripId: string) {
  return useQuery({
    queryKey: ['share-link', tripId],
    queryFn: async () => {
      const response = await fetch(`${API_BASE}/api/trips/${tripId}/share-link`, {
        credentials: 'include',
      });
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      return response.json() as Promise<ShareLink>;
    },
    enabled: !!tripId,
  });
}

export function useGenerateShareLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (tripId: string) => {
      // GET already generates a link if none exists (server-side logic).
      const response = await fetch(`${API_BASE}/api/trips/${tripId}/share-link`, {
        credentials: 'include',
      });
      if (!response.ok) throw new Error(`Failed to generate share link: ${response.status}`);
      return response.json() as Promise<ShareLink>;
    },
    onSuccess: (_, tripId) => {
      queryClient.invalidateQueries({ queryKey: ['share-link', tripId] });
    },
  });
}
